module.exports = __webpack_public_path__ + "static/img/kabaoou.b73759bf.png";